import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { connect } from 'react-redux';
import { Logout } from '../../actions/auth';
import { selectProfile } from '../../actions/profile';

function UserMenu(props) {
  const { onLogout, onSelectProfile, anchorEl, isOpen, onClose } = props;

  return (
    <>
      <Menu
        getContentAnchorEl={null}
        id="simple-menu"
        anchorEl={anchorEl}
        open={isOpen}
        keepMounted
        onClose={onClose}
      >
        <MenuItem onClick={onSelectProfile}>Profile</MenuItem>
        <MenuItem
          onClick={() => {
            onLogout();
            onClose();
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}

UserMenu.defaultProps = {
  onLogout: () => {},
  onSelectProfile: () => {},
  anchorEl: {},
  isOpen: false,
  onClose: () => {},
};

UserMenu.propTypes = {
  onLogout: PropTypes.func,
  onSelectProfile: PropTypes.func,
  anchorEl: PropTypes.instanceOf(Element),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export function mapDispatchToProps(dispatch) {
  return {
    onLogout: () => dispatch(Logout()),
    onSelectProfile: () => dispatch(selectProfile()),
  };
}

export default connect(() => ({}), mapDispatchToProps)(UserMenu);
